<script setup lang="ts">
defineOptions({
  name: 'ImpressumComponent'
})
</script>

<template>
  <div class="px-0 py-0 mx-0 my-0">
    <div class="pt-high">
      <v-row align="center">
        <v-col cols="12" lg="12" class="px-8 px-lg-16">
          <h1 class="text-primary font-weight-regular bannerTitle mb-16">Impressum</h1>
          <h2 class="text-h5 font-weight-regular text-lg-h4 mb-2">Angaben gemäß §5 TMG</h2>
          <p class="text-body-1 mb-12">
            johnsenpartner. architekten<br />
            Inhaber Dipl. Ing. Architekt Andreas Szklarek<br />
            Hansastraße 9<br />
            42697 Solingen
          </p>
          <h2 class="text-h5 font-weight-regular text-lg-h4 mb-2">Kontakt</h2>
          <p class="text-body-1 mb-12">
            <span class="font-weight-semibold">Telefon:</span> 0212.68599611<br />
            <span class="font-weight-semibold">E-Mail:</span> west@johnsenpartner.de
          </p>
          <h2 class="text-h5 font-weight-regular text-lg-h4 mb-2">Steuernummer</h2>
          <p class="text-body-1 mb-12">128/5615/5140</p>
          <h2 class="text-h5 font-weight-regular text-lg-h4 mb-2">
            Redaktionell verantwortlich i.S.v. § 55 II Rundfunkstaatsvertrag (RStV)
          </h2>
          <p class="text-body-1 mb-12">
            Dipl. Ing. Architekt Andreas Szklarek<br />
            Hansastraße 9<br />
            42697 Solingen
          </p>
          <h2 class="text-h5 font-weight-regular text-lg-h4 mb-2">Aufsichtsbehörde</h2>
          <p class="text-body-1 mb-12">
            Architektenkammer Nordrhein-Westfalen (AKNW)<br />
            Zollhof 1<br />
            40221 Düsseldorf <br />
            <a
              class="custom-hyperlink text-primary"
              href="https://www.aknw.de"
              target="_blank"
              rel="noopener noreferrer"
              >www.aknw.de</a
            >
          </p>
          <h2 class="text-h5 font-weight-regular text-lg-h4 mb-2">
            Berufsbezeichnung und berufsrechtliche Regelungen
          </h2>
          <p class="text-body-1 mb-12">
            Berufsbezeichnung nach dem Recht der Bundesrepublik Deutschland und
            Kammermitgliedschaft: Herr Andreas Szklarek trägt den Berufstitel Architekt/Architektin.
            Er ist Mitglied der Architektenkammer Nordrhein-Westfalen. Der Berufstitel wurde in der
            Bundesrepublik Deutschland verliehen.
          </p>
          <h2 class="text-h5 font-weight-regular text-lg-h4 mb-2">Zuständige Kammer</h2>
          <h3 class="text-h6 font-weight-regular text-lg-h5 mb-2">Zuständige Aufsichtsbehörde:</h3>
          <p class="text-body-1 mb-12">
            Architektenkammer Nordrhein-Westfalen (AKNW)<br />
            Körperschaft des öffentlichen Rechts<br />
            Zollhof 1<br />
            40221 Düsseldorf<br />
            <span class="font-weight-semibold">Telefon:</span> (02 11) 49 67-0.<br />
            <span class="font-weight-semibold">Telefax:</span> (02 11) 49 67-99<br />
            <span class="font-weight-semibold">E-Mail:</span> info@aknw.de<br />
            <a
              class="custom-hyperlink text-primary"
              href="https://www.aknw.de"
              target="_blank"
              rel="noopener noreferrer"
              >www.aknw.de</a
            >
          </p>
          <h2 class="text-h5 font-weight-regular text-lg-h4 mb-2">
            Es gelten folgende berufsrechtliche Regelungen
          </h2>
          <p class="text-body-1 mb-12">
            Es gelten folgende berufsrechtlichen Regelungen: Baukammerngesetz für
            Nordrhein-Westfalen (BauKaG NRW), Verordnung zur Durchführung des Baukammerngesetzes
            (DVO BauKaG NRW), die Honorarordnung für Architekten und Ingenieure (HOAI) sowie die
            Berufsordnung, sind einsehbar auf der Website der Landesarchitektenkammer für
            Nordrhein-Westfalen unter
            <a
              class="custom-hyperlink text-primary"
              href="https://www.aknw.de/recht/gesetze-und-verordnungen"
              target="_blank"
              rel="noopener noreferrer"
              >www.aknw.de/recht/gesetze-und-verordnungen</a
            >.
          </p>
          <h2 class="text-h5 font-weight-regular text-lg-h4 mb-2">
            Angaben zur Berufshaftpflichtversicherung
          </h2>
          <p class="text-body-1 mb-12">
            Name und Sitz des Versicherers: AIA AG, Kaistraße 13, 40221 Düsseldorf Geltungsraum der
            Versicherung: Deutschland
          </p>
          <h2 class="text-h5 font-weight-regular text-lg-h4 mb-2">Streitschlichtung</h2>
          <p class="text-body-1">
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
            <a
              class="custom-hyperlink text-primary"
              href="https://ec.europa.eu/consumers/odr"
              target="_blank"
              rel="noopener noreferrer"
              >https://ec.europa.eu/consumers/odr</a
            >. Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit oder
            verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
            teilzunehmen.
          </p>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
